type Row = {
  label: string;
  self: string;
  yamebi: string;
};

const rows: Row[] = [
  { label: "続け方", self: "我慢する", yamebi: "環境を変える" },
  { label: "意志力", self: "強い意志が必要", yamebi: "不要" },
  { label: "疲れた日・ストレス時", self: "つい買ってしまう", yamebi: "そもそも買えない" },
  { label: "続けやすさ", self: "我慢が必要で難しい", yamebi: "自動で続きやすい" },
];

export default function ComparisonSection() {
  return (
    <section className="bg-white py-20 px-6">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-sm text-[#B07040] font-bold tracking-widest uppercase mb-3">COMPARISON</p>
          <h2 className="text-2xl md:text-3xl font-black text-[#1a1a1a] leading-tight">
            我慢してやめるのではなく、<br />
            <span className="text-[#00B900]">環境で続ける購入コントロール</span>へ
          </h2>
        </div>

        {/* PC: テーブル / SP: カード */}
        {/* PC用テーブル */}
        <div className="hidden md:block rounded-2xl border border-gray-200 overflow-hidden">
          <table className="w-full">
            <thead>
              <tr>
                <th className="bg-gray-50 text-gray-500 text-sm font-semibold py-4 px-5 text-left w-[30%]">
                  比較項目
                </th>
                <th className="bg-[#FFF4F2] text-[#E05040] text-sm font-bold py-4 px-5 text-center">
                  自力で我慢する方法
                </th>
                <th className="bg-[#EDFAED] text-[#00A000] text-sm font-bold py-4 px-5 text-center">
                  YAMEBI
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-gray-50/50"}>
                  <td className="py-4 px-5 text-sm font-bold text-[#1a1a1a]">{row.label}</td>
                  <td className="py-4 px-5 text-center">
                    <span className="inline-flex items-center gap-1.5 text-sm text-[#E05040] font-medium">
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-close-circle-fill text-base text-[#E05040]"></i>
                      </span>
                      {row.self}
                    </span>
                  </td>
                  <td className="py-4 px-5 text-center">
                    <span className="inline-flex items-center gap-1.5 text-sm text-[#00A000] font-bold">
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-checkbox-circle-fill text-base text-[#00B900]"></i>
                      </span>
                      {row.yamebi}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* SP用カードレイアウト */}
        <div className="md:hidden space-y-4">
          {rows.map((row, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-200 overflow-hidden">
              <div className="bg-gray-50 px-4 py-2 border-b border-gray-200">
                <p className="text-xs font-bold text-[#555] uppercase tracking-wide">{row.label}</p>
              </div>
              <div className="flex divide-x divide-gray-100">
                <div className="flex-1 px-4 py-4 bg-[#FFF8F7]">
                  <p className="text-[10px] font-bold text-[#E05040] mb-1">自力で我慢</p>
                  <span className="inline-flex items-center gap-1 text-sm text-[#E05040] font-medium">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-close-circle-fill text-base"></i>
                    </span>
                    {row.self}
                  </span>
                </div>
                <div className="flex-1 px-4 py-4 bg-[#F4FBF4]">
                  <p className="text-[10px] font-bold text-[#00A000] mb-1">YAMEBI</p>
                  <span className="inline-flex items-center gap-1 text-sm text-[#00A000] font-bold">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-checkbox-circle-fill text-base"></i>
                    </span>
                    {row.yamebi}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
